import React from 'react'
import CloseModalIcon from 'static/icons/close-modal-icon.svg'
import InfoModalIcon from 'static/icons/info-icon.svg'

import { BodyScrollLock } from 'components/styled'
import {
  ModalBox,
  ModalBody,
  ModalTitle,
  ModalSubtitle,
  ModalContent,
  ModalBackdrop,
  ModalClose,
  InfoIconContent,
  ModalHeader
} from './styles'

const InfoModal = ({
  visible,
  title,
  subtitle,
  children,
  onCancel,
  dataTest,
  modalHeight,
  modalWidth,
  contentWidth
}) => {
  return (
    <>
      <ModalBackdrop visible={visible} onClick={onCancel} data-test={`${dataTest}-backdrop`} />
      <ModalBox visible={visible} data-test={dataTest} modalHeight={modalHeight} modalWidth={modalWidth}>
        <ModalHeader>
          <InfoIconContent>
            <InfoModalIcon />
          </InfoIconContent>
          <ModalTitle data-test={`${dataTest}-title`}>{title}</ModalTitle>
          <ModalClose onClick={onCancel}>
            <CloseModalIcon />
          </ModalClose>
        </ModalHeader>
        <ModalBody contentWidth={contentWidth}>
          {subtitle && <ModalSubtitle data-test={`${dataTest}-subtitle`}>{subtitle}</ModalSubtitle>}
          <ModalContent data-test={`${dataTest}-content`}>{children}</ModalContent>
        </ModalBody>
      </ModalBox>
      <BodyScrollLock active={visible} />
    </>
  )
}

export default InfoModal
